import { styled } from "@mui/material/styles";

export const StyledNotDownloadedIcon = styled("span")(({ theme }) => ({
	display: "inline-flex",
	verticalAlign: "text-bottom",
	marginRight: theme.spacing(theme.spacingTokens.xs),
}));
